import CitySEOHead from "@/components/feature/CitySEOHead";
import OrlandoHeroSection from "./components/HeroSection";
import OrlandoStickyNav from "./components/StickyNav";
import OrlandoProcessingTimeSection from "./components/ProcessingTimeSection";
import OrlandoServicesSection from "./components/ServicesSection";
import OrlandoLocalAreaSection from "./components/LocalAreaSection";
import OrlandoTestimonialsSection from "./components/TestimonialsSection";
import OrlandoAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import OrlandoComparisonSection from "./components/ComparisonSection";
import OrlandoMistakesSection from "./components/MistakesSection";
import OrlandoHowItWorksSection from "./components/HowItWorksSection";
import OrlandoFAQSection, { faqs } from "./components/FAQSection";
import OrlandoHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import { landmarks as orlandoLandmarks } from "./components/HelpfulResourcesSection";
import OrlandoFinalCTA from "./components/FinalCTA";
import OrlandoTravelTimingSection from "./components/TravelTimingSection";
import OrlandoDestinationsSection from "./components/DestinationsSection";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Orlando, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Orlando, FL — as fast as 2–3 business days. A+ BBB rated, registered State Dept. courier serving Orlando, Kissimmee, Winter Park, and Central Florida travelers needing urgent, fast, or same-day passport help.";

const areaServedList = [
  { "@type": "City", name: "Orlando" },
  { "@type": "City", name: "Winter Park" },
  { "@type": "City", name: "Kissimmee" },
  { "@type": "City", name: "Lake Buena Vista" },
  { "@type": "City", name: "Altamonte Springs" },
  { "@type": "City", name: "Dr. Phillips" },
  { "@type": "City", name: "Winter Garden" },
  { "@type": "City", name: "Maitland" },
  { "@type": "AdministrativeArea", name: "Orange County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Orlando, Winter Park, Kissimmee, and Orange County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function OrlandoPage() {
  return (
    <>
      <CitySEOHead
        city="Orlando"
        state="Florida"
        stateAbbr="FL"
        route="/cities/orlando"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Orlando, Florida"
        geoPosition="28.5384;-81.3789"
        keywords="expedited passport Orlando, emergency passport Orlando FL, same day passport Orlando, fast passport Florida, passport renewal Orlando, Orlando passport courier"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        hasPhysicalOffice
        lastModified="2026-06-09"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={orlandoLandmarks}
      />

      <div className="font-sans">
        <OrlandoHeroSection />
        <OrlandoStickyNav />
        <OrlandoProcessingTimeSection />
        <OrlandoLocalAreaSection />
        <OrlandoServicesSection />
        <OrlandoTravelTimingSection />
        <OrlandoDestinationsSection />
        <OrlandoTestimonialsSection />
        <OrlandoAcceptanceFacilitiesSection />
        <OrlandoComparisonSection />
        <OrlandoMistakesSection />
        <OrlandoHowItWorksSection />
        <OrlandoFAQSection />
        <OrlandoHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/orlando" state="FL" />
        <OrlandoFinalCTA />
      </div>
    </>
  );
}